import { t } from "@lingui/macro";
import React from "react";

import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

import {
  FlagIcon,
  PersonFilledIcon,
  PlaceIcon,
} from "../../../../../../../../components/icons_v2/general";
import {
  HStack,
  VStack,
  Text,
} from "../../../../../../../../components/primitive";

type PublicAvailableSlotBodyProps = {
  location?: string;
  time?: string;
  prices?: number[];
  availableSpots?: number;
  rateName?: string;
  layouts?: string[];
};
export const PublicAvailableSlotBody = ({
  location,
  time,
  prices,
  availableSpots,
  layouts,
  rateName,
}: PublicAvailableSlotBodyProps) => {
  const minPrice = prices ? Math.min(...prices) : 0;
  const maxPrice = prices ? Math.max(...prices) : 0;
  const samePrice = minPrice === maxPrice;
  const { currencySymbol } = useGetClubCurrency();
  return (
    <HStack gap={2} justifyContent="space-between">
      <VStack alignItems="flex-start" gap={1}>
        <VStack>
          {location ? (
            <HStack alignItems="center" gap={1}>
              <Text variant="mainTiny" color="text-secondary">
                {location}
              </Text>
              <PlaceIcon color="icon-disabled" />
            </HStack>
          ) : null}
          <Text variant="mainBaseSemiBold" color="text-primary">
            {time ?? ""}
          </Text>
        </VStack>
        <HStack gap={4}>
          <HStack gap={1}>
            <PersonFilledIcon color="icon-disabled" />
            <Text variant="mainTiny">
              {t`Up to`} {availableSpots}
            </Text>
          </HStack>
          {layouts ? (
            <HStack gap={1}>
              <FlagIcon color="icon-disabled" />
              <Text variant="mainTiny">
                {layouts.map((layout) => layout).join(" / ")}
              </Text>
            </HStack>
          ) : null}
        </HStack>
      </VStack>
      <VStack alignItems="flex-end" justifyContent="flex-start">
        {prices ? (
          <Text variant="mainBaseSemiBold" color="main-primary-700">
            {samePrice
              ? `${currencySymbol}${ConvertCentsToDollars(minPrice)}`
              : `${currencySymbol}${ConvertCentsToDollars(
                  minPrice
                )} - ${currencySymbol}${ConvertCentsToDollars(maxPrice)}`}
          </Text>
        ) : null}
        <VStack>
          {rateName ? (
            <Text variant="mainTiny" color="text-secondary">
              {rateName}
            </Text>
          ) : null}
        </VStack>
      </VStack>
    </HStack>
  );
};
